class VariantSwitcher extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', () => {
      this.classList.toggle('is-open');
    });

    this.index = this.getAttribute('data-index');

    this.selectors = {
      variantItem: this.querySelectorAll('.js-variant-switcher__item'),
      switcherTitle: this.querySelector('.js-variant-swithcer__title')
    }

    this.selectors.variantItem.forEach(item => {
      item.addEventListener('click', () => {
        this.selectors.switcherTitle.innerHTML = item.innerHTML;
        this.classList.remove('is-open');
      });
    });

    this.handleWindowClick = this.handleWindowClick.bind(this);
  }

  connectedCallback() {
    window.addEventListener('click', this.handleWindowClick);
  }
  
  disconnectedCallback() {
    window.removeEventListener('click', this.handleWindowClick);
  }
  
  handleWindowClick(event) {
    if (!event.target.closest('variant-switcher') || event.target.closest('variant-switcher') && event.target.closest('variant-switcher').getAttribute('data-index') != this.index) {
      this.classList.remove('is-open');
    }
  }
}

customElements.define('variant-switcher', VariantSwitcher);